import StudentServices from '../../services/scholarships/student';

export const state = {
    students: [],
    student: {},
}

export const mutations = {
    setStudent(state, student) {
        state.student = student
    },
    setStudents(state, students) {
        state.students = students
    }
}

export const getters = {
    getStudent(state) {
        return state.student;
    },
    getStudents(state) {
        return state.students;
    },
}

export const actions = {
    get({commit}, id){
        return StudentServices.get(id)
        .then((response)=>{
            commit('setStudent', response.data.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return StudentServices.getAll(data)
        .then((response)=>{
            commit('setStudents', response.data.data)
            return response
        })
    },
    delete({state, commit}, id){
        return StudentServices.delete(id)
        .then((response)=>{
            commit('setStudents', state.students.filter((x)=>x.id != id))
            return response
        })
    },
    updateStatus({state, commit}, data){
        return StudentServices.updateStatus(data)
        .then((response)=>{
            let students = state.students
            students[students.findIndex((x)=>x.id == data.id)] = response.data.data
            commit('setStudents', students)
            return response
        })
    },
}